import { entityTagsApi } from '../api/entity-tags';

const entityTagHooks = {
  company: entityTagsApi.useGetCompanyTagsQuery
} as const;

export const useEntityTags = <T extends keyof typeof entityTagHooks>(
  entity: T,
  entityId: number
) => {
  const hook = entityTagHooks[entity];
  return hook(entityId);
};
